// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 384) return "static/chunks/384.dab003c49e2989e6.js";
	if (chunkId === 788) return "static/chunks/788.aeb202a6bc03717d.js";
	if (chunkId === 496) return "static/chunks/graphql-print.83edc8afc0370428.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"225":"57671f315ae3f6d7","484":"26ab3b93c2bfa1d9","926":"2c83bfad966d0a11","997":"30ebb42e453a6e4a"}[chunkId] + ".js";
};